'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "SkeletonTitle": "Polaris-SkeletonPage__SkeletonTitle"
};

exports.default = styles;
